import type { PaymentsOpsTransaction } from 'src/interfaces/transactionsReview'

/** Retool's `achTransactionDetails || rtpTransactionDetails || wiresTransactionDetails`. */
export const pickTransactionDetails = (
  transaction: PaymentsOpsTransaction,
): Record<string, unknown> | null => {
  return (
    transaction.achTransactionDetails ??
    transaction.rtpTransactionDetails ??
    transaction.wiresTransactionDetails ??
    null
  )
}
